import { type PropsWithChildren, type ReactElement } from 'react';

import type { TruncationMode } from '../../../../../typography/text-ellipsis/TextEllipsis.js';
import type { PointShapeType } from '../../../../core/components/shape/type.js';
import { ChartTooltip } from '../../../../core/components/tooltip/ChartTooltip/ChartTooltip.js';

/**
 * @internal
 */
export interface XYChartTooltipHeaderProps {
  color: string;
  name: string;
  truncationMode?: TruncationMode;
  actions?: () =>
    | ReactElement<PropsWithChildren>
    | Promise<ReactElement<PropsWithChildren>>;
  defaultActions?: ReactElement<PropsWithChildren>;
  value?: string | string[];
  shape?: PointShapeType;
}

/**
 * Defines the template for the XYChart tooltip header
 * @internal
 */
export function XYChartTooltipHeader({
  color,
  name,
  actions,
  defaultActions,
  truncationMode,
  value,
  shape,
}: Readonly<XYChartTooltipHeaderProps>) {
  const variant = shape === 'circle' ? 'single' : shape;

  return (
    <ChartTooltip.Body>
      <ChartTooltip.SeriesItem
        color={color}
        name={name}
        actions={actions}
        defaultActions={defaultActions}
        truncationMode={truncationMode}
        value={value}
        variant={variant}
      />
    </ChartTooltip.Body>
  );
}

(
  XYChartTooltipHeader as typeof XYChartTooltipHeader & { displayName: string }
).displayName = 'XYChartTooltipHeader';
